enum PaymentAmountOptions {
  Remaining = 'remaining',
  Custom = 'custom',
}

export default PaymentAmountOptions
